import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../globalContext";
import React, { useEffect, useContext } from "react";

function RefLink() {
  const { urlReferral, setUrlReferral } = useContext(GlobalContext);
  const nav = useNavigate();
  const r  = useParams(); // expects route like: /ref/:refLink
    console.log("RefLink got:",  r.refLink );
  useEffect(() => {
    if (!r.refLink){
        nav("/login", { replace: true }); 
    }
    else{
        setUrlReferral(r.refLink);              // store referral
    nav("/signup", { replace: true });
    }                 // nothing to do
        // redirect
  }, [r.refLink]);     // <-- important deps

  return <></>;
}

export default RefLink;